import { OperationDTO } from "@zenith/services/transactions";

export const getPaymentMethodName = (
  code: string | null | undefined
): string => {
  if (!code) return "N/A";

  switch (code) {
    case OperationDTO.paymentMethod.CASH:
      return "Cash";
    case OperationDTO.paymentMethod.USSD:
      return "USSD";
    case OperationDTO.paymentMethod.QR_CODE:
      return "QR Code";
    case OperationDTO.paymentMethod.IN_BANK_TRANSFER:
      return "Pay with Transfer";
    case OperationDTO.paymentMethod.INWARDS_TRANSFER:
      return "Inwards Transfer";
    case OperationDTO.paymentMethod.PAY_WITH_TRANSFER:
      return "Pay with Transfer";
    case OperationDTO.paymentMethod.PAYMENT_LINK_PAY_WITH_TRANSFER:
      return "Payment Link - Pay with Transfer";
    case OperationDTO.paymentMethod.PAYMENT_LINK:
      return "Payment Link";
    case OperationDTO.paymentMethod.OUT_BANK_TRANSFER:
      return "Funds Transfer";
    case OperationDTO.paymentMethod.REFUND:
      return "Refund";
    case OperationDTO.paymentMethod.POS:
      return "POS";
    case OperationDTO.paymentMethod.POS_ORDER:
      return "POS Order";
    case OperationDTO.paymentMethod.CARD:
      return "Card";
    case OperationDTO.paymentMethod.STATIC_ACCOUNT:
      return "Pay with Transfer";
    default:
      return code;
  }
};